module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("TITLE PAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COPYRIGHT NOTICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/credit#credit"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PICTURE CREDITS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#preface"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AUTHOR’S PREFACE TO 2002 EDITION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/preface#h1"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ADDENDUM TO 2007 EDITION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 1: Jewish Forebears")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 2: Fellow-Student of Rabelais")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 3: ‘A Complete Atheist’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 4: Plagued Interlude")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 5: Almanac Entrepreneur")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 6: Prophecies on the Presses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 7: A Tricky Invitation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 8: Dealing in Futures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 9: On Martial Field")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 10: Continent in Thrall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 11: Seeking the Lost")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 12: A Satisfied Client")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 13: Royal Visitors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 14: Matchmaker, Matchmaker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 15: A Princely Horoscope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 16: ‘A Strange Migration’")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 17: Gilding the Legend")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 18: Prophecies Fulfilled?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 19: Plaything of Propagandists")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("CHAPTER")]), _vm._v(" 20: His First 500 Years")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/note#note",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/postscript#script",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("AUTHOR’S POSTSCRIPT")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adc",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ALSO BY IAN WILSON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/praise#praise",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("PRAISE FOR IAN WILSON")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("COPYRIGHT")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0